import { useState, useEffect } from "react";

export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if dismissed recently
    const dismissed = localStorage.getItem("pwa_dismiss");
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 86400000) return;

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show) return null;

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem("pwa_dismiss", Date.now().toString());
  };

  return (
    <div style={{
      position: "fixed", bottom: 72, left: 16, right: 16, zIndex: 110,
      background: "var(--s1)", border: "1px solid var(--bdr)", borderRadius: 12,
      padding: "12px 16px", display: "flex", alignItems: "center", gap: 12,
      boxShadow: "0 8px 32px rgba(0,0,0,.4)", backdropFilter: "blur(12px)",
    }}>
      <div style={{ flex: 1 }}>
        <div style={{ fontFamily: "var(--font-orb)", fontSize: 12, color: "var(--t1)", fontWeight: 700, letterSpacing: ".04em" }}>
          INSTALL APP
        </div>
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 10, color: "var(--t3)", marginTop: 2 }}>
          Add Dentsu AMP to your home screen
        </div>
      </div>
      <button onClick={handleInstall} style={{
        padding: "8px 16px", background: "var(--r)", border: "none", borderRadius: 8,
        fontFamily: "var(--font-mono)", fontSize: 11, color: "#fff", cursor: "pointer",
        fontWeight: 600, letterSpacing: ".04em",
      }}>
        Install
      </button>
      <button onClick={handleDismiss} style={{
        background: "none", border: "none", color: "var(--t3)", cursor: "pointer",
        fontSize: 18, padding: "4px 8px", lineHeight: 1,
      }}>
        &times;
      </button>
    </div>
  );
}
